import React from 'react'
import PropTypes from 'prop-types'
import { trackAnalyticsEvent } from 'analytics'
import { defaultPrivateWealthEmail } from 'utils/links'

const defaultOnClick = () => {
  trackAnalyticsEvent(`Email ${defaultPrivateWealthEmail}`)
}

const PrivateWealthEmailLink = (props) => {
  const { message, className, onClick } = props
  const linkStyles = className || null
  const linkOnClick = onClick || defaultOnClick
  const linkMessage = message || defaultPrivateWealthEmail
  const mailToLink = `mailto:${defaultPrivateWealthEmail}`
  return (
    <a 
      data-test-id="default-private-wealth-email"
      className={linkStyles}
      onClick={linkOnClick}
      href={mailToLink}>
      {linkMessage}
    </a>
  )
}

PrivateWealthEmailLink.defaultProps = {
  message: null,
  className: null,
  onClick: null,
}

PrivateWealthEmailLink.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.string
}

export default PrivateWealthEmailLink



// WEBPACK FOOTER //
// ./src/components/Shared/PrivateWealthEmailLink/PrivateWealthEmailLink.jsx